import React, { Fragment } from 'react'
import { useSelector } from 'react-redux'

import { providesOrganizationSubscriptions } from 'components/Organizations/dataSync'
import { providesApplicationsSubscriptions } from 'components/Applications/dataSync'
import { providesChannelsSubscriptions } from 'components/Channels/dataSync'
import { providesUserDataRefresher } from 'components/Users/dataSync/providesUserDataRefresher'
import { providesUsersSubscriptions } from 'components/Users/dataSync'
import { providesNotesSubscriptions } from 'components/Notes/dataSync'
import { providesNotificationsSubscriptions } from 'components/Notifications/dataSync'
import { providesActivityRegistrySubscriptions } from 'components/ActivityRegistry/dataSync/subscriptions'
import { isDetachedModeEnabled, getActiveModalId } from 'data/ui/selectors'
import { DESKTOP_REDIRECTION } from 'components/Utils/Modal/constants'

const EmptyComponent = () => false

const OrganizationSubscriber = providesOrganizationSubscriptions(EmptyComponent)
const ChannelsSubscriber = providesChannelsSubscriptions(EmptyComponent)
const UsersSubscriber = providesUsersSubscriptions(EmptyComponent)
const UserDataRefresher = providesUserDataRefresher(EmptyComponent)
const NotesSubscriber = providesNotesSubscriptions(EmptyComponent)
const ApplicationsSubscriber = providesApplicationsSubscriptions(EmptyComponent)
const AknowledgementsSubscriber = providesActivityRegistrySubscriptions(
  EmptyComponent
)
const NotificationsSubscriber = providesNotificationsSubscriptions(
  EmptyComponent
)

export default React.memo(function AppSubscribers() {
  const isDetachedMode = useSelector(isDetachedModeEnabled)
  const isDesktopRedirection = useSelector(
    state => getActiveModalId(state) === DESKTOP_REDIRECTION
  )

  const shouldSubscribeToNotifications =
    !isDetachedMode && !isDesktopRedirection

  return (
    <Fragment>
      <OrganizationSubscriber />
      <ChannelsSubscriber />
      <UserDataRefresher />
      <UsersSubscriber />
      <NotesSubscriber />
      {shouldSubscribeToNotifications && <NotificationsSubscriber />}
      <ApplicationsSubscriber />
      <AknowledgementsSubscriber />
    </Fragment>
  )
})
